function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class2, _class3, _descriptor, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { register, dataParam } from 'ovee.js';
import SliderMain from './SliderMain';

var _class = (_dec = register('slider-modal-gallery'), _dec2 = dataParam(), _dec(_class2 = (_class3 = (_temp = /*#__PURE__*/function (_SliderMain) {
  _inherits(_class3, _SliderMain);

  var _super = _createSuper(_class3);

  function _class3() {
    var _this;

    _classCallCheck(this, _class3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "modalName", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(_class3.prototype), "init", this).call(this);

      this.wasInitialized = false; // this.modalName = 'gallery';

      this.modal = document.querySelector("[data-modal=\"".concat(this.modalName, "\"]"));
      this.prevButton = this.$element.querySelector('[data-slide-prev]');
      this.nextButton = this.$element.querySelector('[data-slide-next]');
      this.setControlsClasses();
      this.$on('toggle', this.modal, this.toggleSlider);
      this.$on('click', this.prevButton, this.previousSlide);
      this.$on('click', this.nextButton, this.nextSlide);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = _get(_getPrototypeOf(_class3.prototype), "getOptions", this).call(this);

      return _objectSpread(_objectSpread({}, options), {}, {
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
        touchRatio: 0.5,
        resistance: false,
        runCallbacksOnInit: false,
        init: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
          checkInView: false
        }
      });
    }
  }, {
    key: "toggleSlider",
    value: function toggleSlider() {
      if (!this.wasInitialized) {
        this.wasInitialized = true;
        this.swiper.init();
      }
    }
  }, {
    key: "setControlsClasses",
    value: function setControlsClasses() {
      this.prevButton.classList.remove('is-hidden');
      this.nextButton.classList.remove('is-hidden');

      if (this.swiper.isBeginning) {
        this.prevButton.classList.add('is-hidden');
      } else if (this.swiper.isEnd) {
        this.nextButton.classList.add('is-hidden');
      }
    }
  }, {
    key: "previousSlide",
    value: function previousSlide() {
      this.swiper.slidePrev();
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      this.swiper.slideNext();
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;

      _get(_getPrototypeOf(_class3.prototype), "bind", this).call(this);

      if (this.swiper) {
        this.swiper.on('slideChange', function () {
          _this2.setControlsClasses();
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.wasInitialized) {
        _get(_getPrototypeOf(_class3.prototype), "destroy", this).call(this);
      }

      this.$off('toggle', this.modal, this.toggleSlider);
      this.$off('click', this.prevButton, this.previousSlide);
      this.$off('click', this.nextButton, this.nextSlide);
    }
  }]);

  return _class3;
}(SliderMain), _temp), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, "modalName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3)) || _class2);

export { _class as default };